export { showFlashMessage as default } from 'creators/common/flashMessages'
